// // import React, { useState, useEffect } from "react";
// // import socket from "../socket";
// // import axios from "axios";
// // import "../pages/sales.css";
// // import "../pages/calllogs.css";

// // function SalesExecDashboard() {

// //   const [notifications, setNotifications] = useState([]);

// //   const salesId = 1;

// //   // SOCKET LISTENER
// //   useEffect(() => {
// //     socket.on("meeting_assigned", (data) => {
// //       alert("📢 " + data.message);
// //     });

// //     return () => {
// //       socket.off("meeting_assigned");
// //     };
// //   }, []);

// //   // FETCH NOTIFICATIONS
// //   useEffect(() => {
// //     axios
// //       .get(`http://localhost:5000/api/notifications/${salesId}`)
// //       .then(res => {
// //         setNotifications(res.data);
// //       })
// //       .catch(err => console.log(err));
// //   }, []);

// //   return (
// //     <div className="main-content" style={{ padding: "20px" }}>

// //       <h2>Welcome to Sales Dashboard</h2>

// //       <p>Check your assigned leads from the Assigned Leads module.</p>

// //       {/* OPTIONAL: Notifications count */}
// //       <div style={{ marginTop: "20px" }}>
// //         <strong>Notifications:</strong> {notifications.length}
// //       </div>

// //     </div>
// //   );
// // }

// // export default SalesExecDashboard;


// import React, { useState, useEffect } from "react";
// import socket from "../socket";
// import axios from "axios";
// import "../pages/sales.css";

// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   Tooltip,
//   ResponsiveContainer
// } from "recharts";

// function SalesExecDashboard() {

//   const [notifications, setNotifications] = useState([]);
//   const [meetings, setMeetings] = useState([]);
//   const [deals, setDeals] = useState([]);
//   const [followups, setFollowups] = useState([]);

//   const userId = localStorage.getItem("userId");

//   // ================= SOCKET =================
//   useEffect(() => {
//     socket.on("meeting_assigned", (data) => {
//       alert("📢 " + data.message);
//     });

//     return () => {
//       socket.off("meeting_assigned");
//     };
//   }, []);

//   // ================= FETCH DATA =================
//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     try {
//       const [meetRes, dealRes, followRes, notifRes] = await Promise.all([
//         axios.get(`http://localhost:5000/api/meetings?role=sales_executive&user_id=${userId}`),
//         axios.get(`http://localhost:5000/api/deals`),
//         axios.get(`http://localhost:5000/api/followups`),
//         axios.get(`http://localhost:5000/api/notifications/${userId}`)
//       ]);

//       // 👉 filter only this user's data
//       const myDeals = dealRes.data.filter(d => d.fos_name == userId || d.user_id == userId);
//       const myFollowups = followRes.data.filter(f => f.assigned_to == userId);

//       setMeetings(meetRes.data);
//       setDeals(myDeals);
//       setFollowups(myFollowups);
//       setNotifications(notifRes.data);

//     } catch (err) {
//       console.log(err);
//     }
//   };

//   // ================= CALCULATIONS =================

//   const totalMeetings = meetings.length;
//   const totalDeals = deals.length;
//   const totalFollowups = followups.length;

//   const totalSales = deals.reduce(
//     (sum, d) => sum + Number(d.received_amount || 0),
//     0
//   );

//   // ================= MONTHLY GRAPH =================
//   const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

//   const monthlyData = months.map((month, index) => {
//     const monthDeals = deals.filter(d => {
//       const m = new Date(d.created_at).getMonth();
//       return m === index;
//     });

//     return {
//       month,
//       sales: monthDeals.reduce(
//         (sum, d) => sum + Number(d.received_amount || 0),
//         0
//       )
//     };
//   });

//   return (
//     <div className="main-page">

//       <h2>Sales Executive Dashboard</h2>

//       {/* KPI CARDS */}
//       <div className="kpi-cards">

//         <div className="card">
//           <h4>My Meetings</h4>
//           <p>{totalMeetings}</p>
//         </div>

//         <div className="card">
//           <h4>My Deals</h4>
//           <p>{totalDeals}</p>
//         </div>

//         <div className="card">
//           <h4>My Sales</h4>
//           <p>₹{totalSales}</p>
//         </div>

//         <div className="card">
//           <h4>Followups</h4>
//           <p>{totalFollowups}</p>
//         </div>

//       </div>

//       {/* GRAPH */}
//       <div className="bar-section">

//         <h4>Monthly Sales</h4>

//         <ResponsiveContainer width="100%" height={300}>
//           <BarChart data={monthlyData}>
//             <XAxis dataKey="month" />
//             <YAxis />
//             <Tooltip />
//             <Bar dataKey="sales" fill="#0f3460" />
//           </BarChart>
//         </ResponsiveContainer>

//       </div>

//       {/* NOTIFICATIONS */}
//       <div style={{ marginTop: "20px" }}>
//         <strong>Notifications:</strong> {notifications.length}
//       </div>

//     </div>
//   );
// }

// export default SalesExecDashboard;
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import API from "../services/api";
import { motion } from "framer-motion";

import {
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  LineChart,
  Line
} from "recharts";

import "../pages/sales.css";

const COLORS = ["#4f46e5", "#22c55e", "#f59e0b", "#ef4444"];

function SalesExecDashboard() {

  const { id } = useParams();

  const [calls, setCalls] = useState([]);
  const [followups, setFollowups] = useState([]);
  const [meetings, setMeetings] = useState([]);
  const [deals, setDeals] = useState([]);
  const [target, setTarget] = useState(0); // 🎯 admin-set monthly target

  // ================= FETCH =================
  useEffect(() => {
    fetchAllData();
    fetchTarget();
  }, [id]);

  // 🎯 fetch this month's target — own target ("/targets/me"),
  // or another user's target if an admin is viewing via :id
  const fetchTarget = async () => {
    try {
      const endpoint = id ? `/targets/${id}` : "/targets/me";
      const res = await API.get(endpoint);
      setTarget(Number(res.data?.target_amount || 0));
    } catch (err) {
      console.log("Target fetch error:", err);
    }
  };

  const fetchAllData = async () => {
    try {
      const [callRes, followRes, meetRes, dealRes] = await Promise.all([
        API.get("/calllogs"),
        API.get("/followups"),
        API.get(`/meetings?role=${localStorage.getItem("role")}&user_id=${localStorage.getItem("userId")}`),
        API.get("/deals")
      ]);

      const userId = id || localStorage.getItem("userId");

      setCalls(callRes.data.filter(c => String(c.user_id) === String(userId)));
      setFollowups(followRes.data.filter(f => String(f.user_id) === String(userId)));
      setMeetings(meetRes.data);

      const myDeals = dealRes.data.filter(d =>
        String(d.created_by) === String(userId) ||
        String(d.user_id) === String(userId) ||
        String(d.assigned_to) === String(userId) ||
        String(d.fos_name) === String(userId)
      );

      setDeals(myDeals);

    } catch (err) {
      console.log(err);
    }
  };

  // ================= CALCULATIONS =================

  const totalCalls = calls.length;
  const totalFollowups = followups.length;
  const totalMeetings = meetings.length;
  const totalDeals = deals.length;

  const totalSales = deals.reduce(
    (sum, d) => sum + Number(d.received_amount || 0),
    0
  );

  const conversionRate = totalCalls
    ? ((totalDeals / totalCalls) * 100).toFixed(1)
    : 0;

  const avgDealValue = totalDeals
    ? Math.round(totalSales / totalDeals)
    : 0;

  // ================= MONTHLY DATA =================
  const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

  const monthlyData = months.map((month, index) => {
    const monthDeals = deals.filter(d =>
      new Date(d.created_at).getMonth() === index
    );

    return {
      month,
      sales: monthDeals.reduce((sum, d) => sum + Number(d.received_amount || 0), 0)
    };
  });

  // ================= DAILY TREND =================
  const dailyTrend = Object.values(
    calls.reduce((acc, c) => {
      const date = new Date(c.call_date).toLocaleDateString();
      if (!acc[date]) acc[date] = { date, calls: 0 };
      acc[date].calls += 1;
      return acc;
    }, {})
  );

  // ================= FUNNEL =================
  const funnelData = [
    { name: "Calls", value: totalCalls },
    { name: "Followups", value: totalFollowups },
    { name: "Meetings", value: totalMeetings },
    { name: "Deals", value: totalDeals }
  ];

  // ================= TARGET =================
  // 🎯 target now comes from the admin-set value (see fetchTarget above),
  // no longer hardcoded.

  const pieData = [
    { name: "Achieved", value: totalSales },
    { name: "Remaining", value: Math.max(target - totalSales, 0) }
  ];

  const progress = target > 0 ? Math.min((totalSales / target) * 100, 100) : 0;

  // ================= PACKAGE STATS =================
  const packageStats = Object.values(
    deals.reduce((acc, d) => {
      if (!acc[d.package_name]) {
        acc[d.package_name] = { name: d.package_name, value: 0 };
      }
      acc[d.package_name].value += 1;
      return acc;
    }, {})
  );

  return (
    <div className="dashboard-page">

      {/* HEADER */}
      <motion.div
  initial={{ opacity: 0, y: 40 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.6 }}
  whileHover={{ scale: 1.05 }}
>
        🚀 Sales Executive Dashboard
      </motion.div>

      {/* KPI */}
      <div className="kpi-grid">

        {[
          { title: "Calls", value: totalCalls },
          { title: "Deals", value: totalDeals },
          { title: "Revenue", value: `₹${totalSales}` },
          { title: "Conversion", value: `${conversionRate}%` },
          { title: "Avg Deal", value: `₹${avgDealValue}` },
          { title: "Meetings", value: totalMeetings },
        ].map((item, i) => (

          <motion.div
  initial="hidden"
  animate="visible"
  variants={{
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.15
      }
    }
  }}
>
            <p>{item.title}</p>
            <h2>{item.value}</h2>
          </motion.div>

        ))}

      </div>

      {/* TARGET */}
      <div className="target-box">
        <h4>Monthly Target</h4>
        <p>
          {target > 0
            ? `₹${totalSales} / ₹${target}`
            : "No target set yet — contact your admin"}
        </p>

        <div className="progress-bar">
          <div
            className="progress-fill"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
      </div>

      {/* CHARTS */}
      <div className="chart-grid">

        {/* FUNNEL */}
        <div className="chart-box">
          <h4>Sales Funnel</h4>
          <ResponsiveContainer width="100%" height={250}>
            <BarChart data={funnelData}>
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="value" fill="#22c55e" radius={[6,6,0,0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>

        {/* MONTHLY */}
        <div className="chart-box">
          <h4>Monthly Sales</h4>
          <ResponsiveContainer width="100%" height={250}>
            <BarChart data={monthlyData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="sales" fill="#4f46e5" radius={[8,8,0,0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>

        {/* DAILY */}
        <div className="chart-box">
          <h4>Daily Calls</h4>
          <ResponsiveContainer width="100%" height={250}>
            <LineChart data={dailyTrend}>
              <XAxis dataKey="date" />
              <YAxis />
              <Tooltip />
              <Line type="monotone" dataKey="calls" stroke="#f59e0b" strokeWidth={3}/>
            </LineChart>
          </ResponsiveContainer>
        </div>

        {/* PIE */}
        <div className="chart-box">
          <h4>Target Achievement</h4>
          <ResponsiveContainer width="100%" height={250}>
            <PieChart>
              <Pie data={pieData} dataKey="value" outerRadius={90}>
                {pieData.map((_, i) => (
                  <Cell key={i} fill={COLORS[i % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>

        {/* PACKAGE */}
        <div className="chart-box">
          <h4>Package Performance</h4>
          <ResponsiveContainer width="100%" height={250}>
            <PieChart>
              <Pie data={packageStats} dataKey="value" outerRadius={90}>
                {packageStats.map((_, i) => (
                  <Cell key={i} fill={COLORS[i % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>

      </div>

    </div>
  );
}

export default SalesExecDashboard;